import { Component, OnInit } from '@angular/core';
import { ZoCommonService } from '../framework/core/service/zo-common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'weixin';

  constructor(private zoCommonService: ZoCommonService) {

  }

  ngOnInit(): void {
    this.zoCommonService.setTitle();
  }
}
